// extracted by mini-css-extract-plugin
module.exports = {"confirmationModal":"style_confirmationModal__3NvgH","confirmationModalContent":"style_confirmationModalContent__1GJmy","hideButtons":"style_hideButtons__3vhQE"};